import { IBureauTenantResumo } from './models/bureaus.model';

/** "<id> · <codigo>" e, se houver, "· <nome>" no fim. */
export function rotuloTenant(tenant: IBureauTenantResumo): string {
    const base = `${tenant.tenant} · ${tenant.codigo}`;
    const nome = (tenant.nome || '').trim();

    return nome ? `${base} · ${nome}` : base;
}

/** Nome com o sobrenome só quando existir de fato. */
export function nomePessoa(pessoa: { nome: string; sobrenome: string | null }): string {
    const nome = (pessoa.nome || '').trim();
    const sobrenome = (pessoa.sobrenome || '').trim();

    return sobrenome ? `${nome} ${sobrenome}` : nome;
}
